import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { DeficiencyTypes } from '@core/enums/deficiency-types';
import { DeficienciesCount } from '@core/interfaces/deficiencies-count';
import { UrlService } from '@core/services/url.service';
import { Observable, map } from 'rxjs';
import { DeficiencyMetricInfo } from '../interfaces/deficiency-metric-info';
import { Deficiency } from '../models/deficiency';

@Injectable()
export class DeficiencyService {
  #client = inject(HttpClient);
  #urlService = inject(UrlService);

  public getDeficiencies(inspectionRequestId: string): Observable<Deficiency[]> {
    const url = this.#urlService.getUrl(`inspection-requests/${inspectionRequestId}/deficiencies`);

    return this.#client
      .get<DeficiencyMetricInfo[]>(url)
      .pipe(
        map(deficiencies =>
          deficiencies.map(
            deficiency =>
              new Deficiency(
                deficiency.deficiencyType,
                deficiency.equipmentId,
                deficiency.equipmentId,
                deficiency.cml,
                deficiency.finding,
                deficiency.ISPRecommendation,
                deficiency.ISPRecommendation,
                deficiency.eventId,
                deficiency.circuitId,
                deficiency.projectId,
              ),
          ),
        ),
      );
  }

  public getDeficienciesCount(inspectionRequestId: string): Observable<DeficienciesCount> {
    const url = this.#urlService.getUrl(`inspection-requests/${inspectionRequestId}/deficiencies`);
    return this.#client.get<{ deficiencyType: DeficiencyTypes }[]>(url).pipe(
      map(data => ({
        utAlarmsCount: this.totalCountOf([DeficiencyTypes.UTAlarm], data),
        redliningsCount: this.totalCountOf([DeficiencyTypes.Redlining], data),
        emergencyCount: this.totalCountOf([DeficiencyTypes.Emergency], data),
        highCount: this.totalCountOf([DeficiencyTypes.High], data),
        standardCount: this.totalCountOf([DeficiencyTypes.Standard], data),
        routineCount: this.totalCountOf([DeficiencyTypes.Routine], data),
        observationCount: this.totalCountOf([DeficiencyTypes.Observation], data),
      })),
    );
  }

  protected totalCountOf(categories: DeficiencyTypes[], data: { deficiencyType: DeficiencyTypes }[]): number {
    return data
      ? data.reduce(
          (prev, curr) =>
            prev +
            categories.reduce(
              (p, c) =>
                p + (curr.deficiencyType.toLocaleLowerCase().replace(/\s/g, '') === c.toLocaleLowerCase().replace(/\s/g, '') ? 1 : 0),
              0,
            ),
          0,
        )
      : 0;
  }
}
